(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-electronics-premium"]) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.kp-electronics-product');

  roots.forEach(function (root) {
    /* ---- Quantity stepper ---- */
    var qtyInput = root.querySelector('.kp-ep-qty__input');
    var minusBtn = root.querySelector('[data-kp-qty-minus]');
    var plusBtn = root.querySelector('[data-kp-qty-plus]');

    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    /* ---- Variant option selects -> hidden id input ---- */
    var selects = root.querySelectorAll('.kp-ep-option__select');
    var variantsJsonEl = root.querySelector('.kp-ep-variants-json');
    var hiddenIdInput = root.querySelector('.kp-ep-variant-id-input');
    var addBtn = root.querySelector('[data-kp-add-to-cart]');
    var addLabel = root.querySelector('[data-kp-add-label]');
    var priceEl = root.querySelector('.kp-ep-price');
    var compareEl = root.querySelector('.kp-ep-price--compare');

    if (selects.length && variantsJsonEl && hiddenIdInput) {
      var variants = [];
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        variants = [];
      }

      var updateVariant = function () {
        var chosen = Array.prototype.map.call(selects, function (s) {
          return s.value;
        });

        var match = variants.filter(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(Boolean);
          return chosen.every(function (val, i) {
            return opts[i] === val;
          });
        })[0];

        if (!match) return;

        hiddenIdInput.value = match.id;

        if (priceEl && match.price != null) {
          priceEl.textContent = formatMoney(match.price);
        }
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
        }
        if (addLabel) {
          addLabel.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      };

      var formatMoney = function (cents) {
        return '₹' + (cents / 100).toFixed(2);
      };

      selects.forEach(function (s) {
        s.addEventListener('change', updateVariant);
      });
    }

    /* ---- Interactive door demo ---- */
    var doorDemo = root.querySelector('[data-kp-door-demo]');
    var doorToggle = root.querySelector('[data-kp-door-toggle]');
    var doorToggleLabel = root.querySelector('[data-kp-door-toggle-label]');

    if (doorDemo && doorToggle) {
      doorToggle.addEventListener('click', function () {
        var isOpen = doorDemo.getAttribute('data-state') === 'open';
        var next = isOpen ? 'closed' : 'open';
        doorDemo.setAttribute('data-state', next);
        doorToggle.setAttribute('aria-pressed', String(!isOpen));
        if (doorToggleLabel) {
          doorToggleLabel.textContent = next === 'open' ? 'Close Door' : 'Open Door';
        }
      });
    }

    /* ---- FAQ accordion ---- */
    var faqTriggers = root.querySelectorAll('[data-kp-faq-trigger]');
    faqTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.hidden = expanded;
        }
      });
    });

    /* ---- Smooth scroll to purchase form ---- */
    var scrollTriggers = root.querySelectorAll('[data-kp-scroll-to-form]');
    scrollTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        var form = root.querySelector('#kp-ep-product-form');
        if (form) {
          evt.preventDefault();
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var qty = form.querySelector('.kp-ep-qty__input');
          if (qty) qty.focus({ preventScroll: true });
        }
      });
    });

    /* ---- Related products (self-contained fetch, no external asset dependency) ---- */
    var relatedWrap = root.querySelector('[data-kp-related]');
    if (relatedWrap) {
      var relatedUrl = relatedWrap.getAttribute('data-url');
      if (relatedUrl && window.fetch) {
        fetch(relatedUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var freshGrid = doc.querySelector('[data-kp-related]');
            if (freshGrid && freshGrid.innerHTML.trim() !== '') {
              relatedWrap.innerHTML = freshGrid.innerHTML;
            }
          })
          .catch(function () {
            /* Network or parse failure: leave whatever server-rendered markup was already there. */
          });
      }
    }

    /* ---- Scroll reveal ---- */
    var revealEls = root.querySelectorAll('.kp-reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('kp-is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('kp-is-visible');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
